export class ErrorHasOccurred extends Error {}
